import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  GLOBAL_STATE,
  WORK_PLAN_ASSIGNED_ALL,
  WORK_PLAN_CREATE,
  WORK_PLAN_CREATED_ALL,
  WORK_PLAN_DELETE,
  WORK_PLAN_STAFF_LIST,
  WORK_PLAN_UPDATE,
  WORK_PLAN_UPDATE_STATUS,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const WORK_PLAN = GLOBAL_STATE

export const { reducer: workPlanReducer } = createSlice({
  name: WORK_PLAN,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.workPlanCreatedAll.pending, state => {
        state[WORK_PLAN_CREATED_ALL].loading = true
      })
      .addCase(actionCreators.workPlanCreatedAll.rejected, (state, action) => {
        state[WORK_PLAN_CREATED_ALL].loading = false
        state[WORK_PLAN_CREATED_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.workPlanCreatedAll.fulfilled, (state, action) => {
        state[WORK_PLAN_CREATED_ALL].loading = false
        state[WORK_PLAN_CREATED_ALL].error = null
        state[WORK_PLAN_CREATED_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.workPlanCreate.pending, state => {
        state[WORK_PLAN_CREATE].loading = true
      })
      .addCase(actionCreators.workPlanCreate.rejected, (state, action) => {
        state[WORK_PLAN_CREATE].loading = false
        state[WORK_PLAN_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.workPlanCreate.fulfilled, (state, action) => {
        state[WORK_PLAN_CREATE].loading = false
        state[WORK_PLAN_CREATE].error = null
        state[WORK_PLAN_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.workPlanDelete.pending, state => {
        state[WORK_PLAN_DELETE].loading = true
      })
      .addCase(actionCreators.workPlanDelete.rejected, (state, action) => {
        state[WORK_PLAN_DELETE].loading = false
        state[WORK_PLAN_DELETE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.workPlanDelete.fulfilled, (state, action) => {
        state[WORK_PLAN_DELETE].loading = false
        state[WORK_PLAN_DELETE].error = null
        state[WORK_PLAN_DELETE].data = action.payload
      })

    builder
      .addCase(actionCreators.workPlanUpdate.pending, state => {
        state[WORK_PLAN_UPDATE].loading = true
      })
      .addCase(actionCreators.workPlanUpdate.rejected, (state, action) => {
        state[WORK_PLAN_UPDATE].loading = false
        state[WORK_PLAN_UPDATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.workPlanUpdate.fulfilled, (state, action) => {
        state[WORK_PLAN_UPDATE].loading = false
        state[WORK_PLAN_UPDATE].error = null
        state[WORK_PLAN_UPDATE].data = action.payload
      })

    builder
      .addCase(actionCreators.workPlanUpdateStatus.pending, state => {
        state[WORK_PLAN_UPDATE_STATUS].loading = true
      })
      .addCase(actionCreators.workPlanUpdateStatus.rejected, (state, action) => {
        state[WORK_PLAN_UPDATE_STATUS].loading = false
        state[WORK_PLAN_UPDATE_STATUS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.workPlanUpdateStatus.fulfilled, (state, action) => {
        state[WORK_PLAN_UPDATE_STATUS].loading = false
        state[WORK_PLAN_UPDATE_STATUS].error = null
        state[WORK_PLAN_UPDATE_STATUS].data = action.payload
      })

    builder
      .addCase(actionCreators.workPlanAssignedAll.pending, state => {
        state[WORK_PLAN_ASSIGNED_ALL].loading = true
      })
      .addCase(actionCreators.workPlanAssignedAll.rejected, (state, action) => {
        state[WORK_PLAN_ASSIGNED_ALL].loading = false
        state[WORK_PLAN_ASSIGNED_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.workPlanAssignedAll.fulfilled, (state, action) => {
        state[WORK_PLAN_ASSIGNED_ALL].loading = false
        state[WORK_PLAN_ASSIGNED_ALL].error = null
        state[WORK_PLAN_ASSIGNED_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.workPlanStaffList.pending, state => {
        state[WORK_PLAN_STAFF_LIST].loading = true
      })
      .addCase(actionCreators.workPlanStaffList.rejected, (state, action) => {
        state[WORK_PLAN_STAFF_LIST].loading = false
        state[WORK_PLAN_STAFF_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.workPlanStaffList.fulfilled, (state, action) => {
        state[WORK_PLAN_STAFF_LIST].loading = false
        state[WORK_PLAN_STAFF_LIST].error = null
        state[WORK_PLAN_STAFF_LIST].data = action.payload
      })

    builder.addCase(actionCreators.workPlanCreatedAllClear, state => {
      state[WORK_PLAN_CREATED_ALL] = defaultState()
    })

    builder.addCase(actionCreators.workPlanAssignedAllClear, state => {
      state[WORK_PLAN_ASSIGNED_ALL] = defaultState()
    })

    builder.addCase(actionCreators.workPlanStaffListClear, state => {
      state[WORK_PLAN_STAFF_LIST] = defaultState()
    })
  },
})
